'use strict';

var _ = require('lodash');
var ConfigurationFlightTagTransformerFactory = function ConfigurationFlightTagTransformerFactory($rootScope, DataTransformer, momentService, MomentConstants) {
  function ConfigurationFlightTagTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-flight-tag-mode';
    this.priority = 1;
  }
  ConfigurationFlightTagTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  ConfigurationFlightTagTransformerFactory.constructor = ConfigurationFlightTagTransformerFactory;
  ConfigurationFlightTagTransformerFactory.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationFlightTagTransformerFactory.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationFlightTagTransformerFactory.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationFlightTagTransformerFactory.prototype.transform = function (data) {
    var flightTags = data.domain.results;
    var result = [];
    var memoizedMomentOfDate = _.memoize(getMomentOfDate);
    var memoizedMomentOfTime = _.memoize(getMomentOfTime);
    for (var i = 0; i < flightTags.length; ++i) {
      var value = flightTags[i];
      var memoizedDepartureDateRangeStart = memoizedMomentOfDate(value.departureDateRangeStart, momentService.FIELD.DEPARTURE_DATE);
      var memoizedDepartureDateRangeEnd = memoizedMomentOfDate(value.departureDateRangeEnd, momentService.FIELD.DEPARTURE_DATE);
      var memoizedDepartureTimeRangeStart = memoizedMomentOfTime(value.departureTimeRangeStart, momentService.FIELD.DEPARTURE_TIME, memoizedMomentOfDate);
      var memoizedDepartureTimeRangeEnd = memoizedMomentOfTime(value.departureTimeRangeEnd, momentService.FIELD.DEPARTURE_TIME, memoizedMomentOfDate);
      var flightTag = {
        technicalId: value.technicalId,
        flightTagName: value.flightTagName,
        carrierCode: value.carrierCode,
        season: value.season ? value.season.toString() : undefined,
        flightNumber: value.flightNumber ? value.flightNumber.toString() : undefined,
        legOrigin: value.legOrigin ? value.legOrigin : undefined,
        legDestination: value.legDestination ? value.legDestination : undefined,
        departureDateRangeStart: value.departureDateRangeStart ? memoizedDepartureDateRangeStart : undefined,
        departureDateRangeEnd: value.departureDateRangeEnd ? memoizedDepartureDateRangeEnd : undefined,
        departureDateDaysOfWeek: value.departureDateDaysOfWeek ? value.departureDateDaysOfWeek.toString() : undefined,
        createdAt: memoizedMomentOfDate(value.createdAt, momentService.FIELD.CREATED_DATE),
        lastUpdatedAt: memoizedMomentOfDate(value.lastUpdatedAt, momentService.FIELD.LAST_UPDATED_AT),
        departureTimeRangeStart: value.departureTimeRangeStart ? memoizedDepartureTimeRangeStart : undefined,
        departureTimeRangeEnd: value.departureTimeRangeEnd ? memoizedDepartureTimeRangeEnd : undefined
      };
      result.push(flightTag);
    }
    return result;
  };
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  function getMomentOfTime(date, field, memorizedMomentOfDate) {
    return memorizedMomentOfDate(date, field, MomentConstants.FORMATS.TIME_ISO);
  }
  return ConfigurationFlightTagTransformerFactory;
};
ConfigurationFlightTagTransformerFactory.$inject = ['$rootScope', 'DataTransformerFactory', 'MomentService', 'MomentConstants'];
module.exports = ConfigurationFlightTagTransformerFactory;